import { render, staticRenderFns } from "./Signatures.vue?vue&type=template&id=39e4d470"
import script from "./Signatures.vue?vue&type=script&lang=js"
export * from "./Signatures.vue?vue&type=script&lang=js"
import style0 from "./Signatures.vue?vue&type=style&index=0&id=39e4d470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports